import { ATC_EXTERNAL_TOGGLE, WeblabedFeatures } from 'src/commons/constants';
import { useIsFeatureEnabled } from 'src/commons/hooks';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

export const canShowSalesAssistant = (userEmail) => {
  const isSalesAssistantEnabled = useIsFeatureEnabled(
    WeblabedFeatures.SALES_ASSISTANT,
  );

  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const { isInternalView } = internalChromeConfig;
  const canShowSalesAssistant =
    isSalesAssistantEnabled &&
    isInternalView &&
    !(window.sessionStorage.getItem(ATC_EXTERNAL_TOGGLE) == 'true');

  const isAmazonEmail = userEmail.toLowerCase().includes('amazon.');

  return canShowSalesAssistant && isAmazonEmail;
};
